module.exports = __webpack_public_path__ + "img/side-bar-shadow.9a2629a3.svg";